import { Controller } from "@hotwired/stimulus"
import { EditorView, basicSetup } from "codemirror"
import { sql } from "@codemirror/lang-sql"
import { html } from "@codemirror/lang-html"
import { css } from "@codemirror/lang-css"
import { php } from "@codemirror/lang-php"
import { javascript } from "@codemirror/lang-javascript"

const LANGUAGES = { sql, html, css, php, javascript }

export default class extends Controller {
  static targets = ["editor", "input"]
  static values = { language: String }

  connect() {
    this.editorTarget.replaceChildren()
    const extension = LANGUAGES[this.languageValue]
    this.view = new EditorView({
      doc: this.inputTarget.value,
      extensions: extension ? [basicSetup, extension()] : [basicSetup],
      parent: this.editorTarget
    })
    this.form = this.element.closest("form")
    if (this.form) {
      this.onFormSubmit = () => this.sync()
      this.form.addEventListener("submit", this.onFormSubmit)
    }
  }

  disconnect() {
    if (this.form) this.form.removeEventListener("submit", this.onFormSubmit)
    if (this.view) this.view.destroy()
  }

  sync() {
    this.inputTarget.value = this.view.state.doc.toString()
  }
}
